"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BoxStyle = exports.BoxStyle = function () {
  function BoxStyle(input) {
    return input == null || input != null && (input.padding === undefined || typeof input.padding === 'string') && (input.margin === undefined || typeof input.margin === 'string') && (input.textShadow === undefined || typeof input.textShadow === 'string') && (input.boxShadow === undefined || typeof input.boxShadow === 'string') && (input.background === undefined || typeof input.background === 'string') && (input.backgroundColor === undefined || typeof input.backgroundColor === 'string') && (input.backgroundImage === undefined || typeof input.backgroundImage === 'string') && (input.backgroundPosition === undefined || typeof input.backgroundPosition === 'string') && (input.backgroundSize === undefined || typeof input.backgroundSize === 'string');
  }

  ;
  Object.defineProperty(BoxStyle, Symbol.hasInstance, {
    value: function value(input) {
      return BoxStyle(input);
    }
  });
  return BoxStyle;
}();

var TextStyle = exports.TextStyle = function () {
  function TextStyle(input) {
    return input == null || BoxStyle(input) && input != null && (input.fontSize === undefined || typeof input.fontSize === 'string') && (input.lineHeight === undefined || typeof input.lineHeight === 'string' || typeof input.lineHeight === 'number') && (input.fontFamily === undefined || typeof input.fontFamily === 'string') && (input.color === undefined || typeof input.color === 'string');
  }

  ;
  Object.defineProperty(TextStyle, Symbol.hasInstance, {
    value: function value(input) {
      return TextStyle(input);
    }
  });
  return TextStyle;
}();

var ImageStyle = exports.ImageStyle = function () {
  function ImageStyle(input) {
    return input == null || BoxStyle(input) && input != null && (input.width === undefined || typeof input.width === 'number') && (input.height === undefined || typeof input.height === 'number');
  }

  ;
  Object.defineProperty(ImageStyle, Symbol.hasInstance, {
    value: function value(input) {
      return ImageStyle(input);
    }
  });
  return ImageStyle;
}();


//////////////////
// WEBPACK FOOTER
// ../lib/types/styles.js
// module id = 101
// module chunks = 0